import React from 'react';
import './App.css';
import { Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import ScrollToTop from "./components/ScrollToTop";
import Header from './components/Header';
import Footer from './components/Footer';

// Pages
import Home from './pages/Home';
import AboutUs from './pages/about/AboutUs';
import ClientTestimonials from './pages/about/ClientTestimonials';
import WhyChooseUs from './pages/about/WhyChooseUs';
import Industries from './pages/Industries';
import Services from './pages/Services';
import ServiceDetails from './pages/ServiceDetails';
import Resources from './pages/Resources';
import Jobs from './pages/Jobs';
import JobDetails from "./pages/JobDetails";
import Contact from './pages/Contact';

// Industry Sub Pages
import Technology from './pages/industries/Technology';
import Healthcare from './pages/industries/Healthcare';
import Finance from './pages/industries/Finance';
import Retail from './pages/industries/Retail';
import Education from './pages/industries/Education';
import Manufacturing from './pages/industries/Manufacturing';

import NewsDetails from "./pages/NewsDetails";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

function App() {
  const location = useLocation();

  return (
    <div className="App">
      <Header />
      <ScrollToTop />
      <AnimatePresence mode="wait">
        <Routes location={location} key={location.pathname}>
          <Route path="/" element={<Home />} />

          {/* About Routes */}
          <Route path="/about" element={<AboutUs />} />
          <Route path="/about/client-testimonials" element={<ClientTestimonials />} />
          <Route path="/about/why-choose-us" element={<WhyChooseUs />} />

          {/* Industries Routes */}
          <Route path="/industries" element={<Industries />} />
          {/* Industries Routes */}
          <Route path="/industries" element={<Industries />} />
          <Route path="/industries/technology" element={<Technology />} />
          <Route path="/industries/healthcare" element={<Healthcare />} />
          <Route path="/industries/finance" element={<Finance />} />
          <Route path="/industries/retail" element={<Retail />} />
          <Route path="/industries/education" element={<Education />} />
          <Route path="/industries/manufacturing" element={<Manufacturing />} />

          {/* Other Routes */}
          <Route path="/services" element={<Services />} />
          <Route path="/services/:id" element={<ServiceDetails />} />
          <Route path="/resources/:slug" element={<NewsDetails />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/jobs" element={<Jobs />} />
          <Route path="/jobs/:id" element={<JobDetails />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </AnimatePresence>
      <Footer />
    </div>
  );
}

export default App;